import React, {useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import {ArrowBack, Edit} from "@mui/icons-material";
import {StyledTableCell, StyledTableRow} from "../../components/Event/EventTable";
import {useGetEventPilotRegistrationsQuery} from "../../slices/apiSlice";
import {
    countryArray, eventStatus, registrationStatus
} from "../../util/standards-util";
import {Alert, Chip, Dialog, DialogContent, Stack} from "@mui/material";
import {findFlagUrlByIso2Code} from 'country-flags-svg';
import Tooltip from "@mui/material/Tooltip";
import Link from "@mui/material/Link";
import PilotInfo from "./PilotInfo";
import Typography from "@mui/material/Typography";
import EventRegistrationStatusWidget from "../../components/Event/EventRegistrationStatusWidget";
import RefreshPilotRankingsWidget from "../../components/Event/RefreshPilotRankingsWidget";
import DownloadEntryListWidget from "../../components/Event/DownloadEntryListWidget";
import {SGP} from "../Competition/sgp-results-react";
import {getEventDatesString} from "../Calendar";


const PilotEntryList = ({event, hasEventManagerScope}) => {

    const eventId = event.id
    const [mode, setMode] = React.useState('list')
    const [pilotData, setPilotData] = React.useState()
    const [entries, setEntries] = React.useState()
    const [pilotRlId, setPilotRlId] = React.useState()

    const {data, isSuccess} =
        useGetEventPilotRegistrationsQuery({eventId:eventId})

    const handleEditClicked = (e, c) => {
        e.stopPropagation()
        const id = e.target.value ? e.target.value : e.target.parentNode.value ? e.target.parentNode.value : e.target.parentNode.parentNode.value
    }

    const handlePilotClicked = (e,id) => {
        e.stopPropagation()
        setPilotRlId(id)
        setMode('rlPilotInfo')
    }

    const handleSelectClicked = (e,id)=> {

        const registration = data.registrations.find( r => r.i === id)
        const pilot = data.pilots.find(p => p.id === registration.p)
        const details = data.details?.find( d => d.i === registration.i)
        setPilotData({
            registration: registration,
            pilot: pilot,
            details: details,
        })

        setMode('pilotInfo')
    }

    useEffect(() => {
        if (isSuccess) {
            let entries=[]

            entries=data.registrations.map((reg)=>{
                return {
                    registration:reg,
                    details:data.details?.find( d => d.i === reg.i),
                    pilot:data.pilots.find(p => p.id === reg.p),
                }
            }).filter((entry)=>{
                return entry.registration.u === registrationStatus.STATUS_APPROVED
            }).sort((a,b) => {
                return a.registration.e.localeCompare(b.registration.e)
            })

            setEntries(entries)
        }
    }, [isSuccess]);

    const onClosePilotInfo = () => {
        setMode('list')
    }

    const onCloseRlPilotInfo = () => {
        setMode('list')
        setPilotRlId()
    }


    return (
        <>
            <Box sx={{
                display:'flex',
                alignItems:'center',
                //justifyContent:'space-between',
                my:'1em',
                columnGap:'2em',
            }}>
                <Typography variant={'h2'} flexGrow={1} textAlign={'left'}>Pilots</Typography>
                { hasEventManagerScope &&
                    <DownloadEntryListWidget event={event}/>
                }
            </Box>
            <Box sx={{textAlign:'left',bgcolor:'#113248',color:'#ffffff'}} mb={3} p={2}>
                <Stack direction={'row'}>
                    <Box mr={'24px'}>
                        <img src='/etc/img/sgp-series-logo-v3.png' alt="SGP" style={{width:'160px'}}/>
                    </Box>
                    <Box>
                        <Typography variant={'h5'}>{SGP.getChampionshipTitle(event)}</Typography>
                        <Typography variant={'h5'}>{event.fullEditionTitle}</Typography>
                        <Typography variant={'h6'}>{event.venue}</Typography>
                        <Typography variant={'h6'}>{getEventDatesString(event)}</Typography>
                    </Box>
                </Stack>
            </Box>
            {entries && mode === 'list' &&
                <TableContainer component={'div'}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell sx={{textAlign:'center'}}>ID</StyledTableCell>
                                <StyledTableCell>Pilot</StyledTableCell>
                                <StyledTableCell sx={{textAlign:'center'}}>Nationality</StyledTableCell>
                                <StyledTableCell>Sailplane</StyledTableCell>
                                {hasEventManagerScope && <StyledTableCell>Email</StyledTableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {entries.map((entry,idx) => {
                                    const reg= entry.registration
                                    const pilot = entry.pilot
                                    const details = entry.details
                                    return (
                                        <StyledTableRow
                                            key={reg.i}
                                            sx={{
                                                '&:last-child td, &:last-child th': {border: 0},
                                                "&:hover": {backgroundColor: "#D3EDF4 !important"},
                                            }}
                                            onClick={(e) => {
                                                handleSelectClicked(e, reg.i)
                                            }}
                                        >
                                            <StyledTableCell component="th" scope="row"  sx={{textAlign:'center'}}>
                                                <div style={{display:'inline-block',background:'#ffffff',padding:'1px 3px',marginTop:'-2px',marginBottom:'-2px',borderRadius:'4px',verticalAlign:'text-bottom',fontSize:'10pt',border:'1px solid #999999'}}>{reg.e}</div>
                                            </StyledTableCell>
                                            <StyledTableCell><Link underline={"none"} onClick={(e) => {handlePilotClicked(e,reg.d)}} sx={{cursor:'pointer'}}>{pilot.firstname} {pilot.lastname}</Link></StyledTableCell>
                                            <StyledTableCell sx={{textAlign:'center'}}><Tooltip title={countryArray.find( c => c.key===pilot.nationality).label} arrow><img src={findFlagUrlByIso2Code(pilot.nationality)} style={{height:'1.2em'}}/></Tooltip></StyledTableCell>
                                            <StyledTableCell>{reg.f}</StyledTableCell>
                                            {hasEventManagerScope && <StyledTableCell>{details?.email ? <Link href={`mailto:${details?.email}`} underline="none" onClick={(evt) => {evt.stopPropagation()}}>{details?.email}</Link> : ""}</StyledTableCell>}
                                        </StyledTableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            {entries && mode === 'list' && entries.length === 0 &&
                <Alert severity={'info'} sx={{textAlign:'center'}}>There are no pilots registered for this event</Alert>
            }
            {isSuccess && mode === 'pilotInfo' &&
                <PilotInfo entry={pilotData} onClose={onClosePilotInfo}/>
            }
            { mode === 'rlPilotInfo' &&
                <Dialog onClose={onCloseRlPilotInfo} open={true} fullWidth maxWidth="lg">
                    <DialogContent sx={{height:'80vh',display:'flex',flexDirection:'column',alignContent:'center'}}>
                        <Box sx={{
                            display:'flex',
                            alignItems:'center',
                            //justifyContent:'space-between',
                            my:'1em',
                            columnGap:'2em',
                        }}>
                            <IconButton onClick={()=>{onCloseRlPilotInfo()}}><ArrowBack/></IconButton>
                            <Typography variant={'h2'} flexGrow={1} textAlign={'left'}>Pilot profile</Typography>
                        </Box>
                        <Box flexGrow={1}>
                            <iframe src={`https://rankingdata.fai.org/SGP_displaypilotdets.php?pilotid=${pilotRlId}`}
                                    height={'100%'}
                                    width={'100%'}
                                    style={{border:'none'}}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
            }
        </>
    )
}

export default PilotEntryList